import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import add from "date-fns/add";
import classnames from "classnames";

import "./DatePicker.css";

import Col from "../../uiElements/grid/Col";
import DateTimeIcon from "../../uiElements/icons/onboardingIcons/DateTimeIcon";

const DateTimePicker = ({
  mode,
  value,
  onChange,
  id,
  sTime,
  sDate,
  period,
  placeholder,
  previousDate,
  type,
  className,
  slots,
  customInput,
  calendarType,
  startDate,
  endDate,
  MaxDate
}) => {
  const excluded = [];
  if (mode === "time") {
    const parseTime = (hour, minutes) => {
      return parseInt(hour) * 60 + parseInt(minutes);
    };

    slots &&
      slots.forEach((slot, index) => {
        if (slots?.length - 1 !== index) {
          const stTime = parseTime(
            slot?.startTime?.hour,
            slot?.startTime?.minutes
          );
          const edTime = parseTime(slot?.endTime?.hour, slot?.endTime?.minutes);

          for (var i = stTime; i <= edTime; i = i + 10) {
            let hour = Math.floor(i / 60);
            let minutes = i % 60;
            excluded.push(setHours(setMinutes(new Date(), minutes), hour));
          }
        }
      });
  }
  const CustomInput = React.forwardRef((props, ref) => {
    return (
      <div onClick={props.onClick} className="row label-row">
        <Col className="mt-2 mb-n1">
          <label
            className="label"
            style={{
              color: props.value ? "#707070" : "#ced4da",
            }}
          >
            {props.value || props.placeholder}
          </label>
        </Col>
        <Col className="mt-n5 mb-2">
          <div style={{ marginTop: "2%", marginLeft: "95%" }}>
            <DateTimeIcon type="calenderButton" />
          </div>
        </Col>
      </div>
    );
  });

  const MultiDateInput = React.forwardRef((props, ref) => {
    return (
      <div
        onClick={props.onClick}
        className="w-100 d-flex ml-auto"
        style={{
          border: "none",
        }}
      >
        <div>
          <label className="datepicker-label pr-3">{value}</label>
        </div>
        <div>
          <div>
            <svg
              width="12"
              height="8"
              viewBox="0 0 12 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.293 0.292969L6.00003 4.58597L1.70703 0.292969L0.29303 1.70697L6.00003 7.41397L11.707 1.70697L10.293 0.292969Z"
                fill="#707070"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  });

  const DefaultContainer = ({ className, children }) => {
    return (
      <div style={{ color: "#fff" }}>
        <div className={className} style={{ display: "inline-grid" }}>
          <div className="datePicker border-bottom" style={{ width: "100%" }}>
            {children}
          </div>
        </div>
      </div>
    );
  };

  return mode === "time" ? (
    <DatePicker
      className="form-group form-control"
      selected={
        value && setHours(setMinutes(new Date(), value.minutes), value.hour)
      }
      showTimeSelect
      showTimeSelectOnly
      timeFormat="hh:mm a"
      placeholderText={`Select ${id === "startTime" ? "Start" : "End"} Time`}
      minTime={
        (sTime &&
          id === "endTime" &&
          setHours(
            setMinutes(
              new Date(),
              sTime.minutes === 50 ? 0 : sTime.minutes + 10
            ),
            sTime.minutes === 50 ? sTime.hour + 1 : sTime.hour
          )) ||
        setHours(
          setMinutes(new Date(), id === "startTime" ? 0 : 10),
          (period === "morning" && 8) ||
            (period === "afternoon" && 12) ||
            (period === "evening" && 18)
        )
      }
      maxTime={setHours(
        setMinutes(new Date(), id === "endTime" ? 0 : 50),
        id === "endTime"
          ? (period === "morning" && 12) ||
              (period === "afternoon" && 18) ||
              (period === "evening" && 23)
          : (period === "morning" && 11) ||
              (period === "afternoon" && 17) ||
              (period === "evening" && 22)
      )}
      timeIntervals={10}
      dateFormat="hh:mm aa"
      excludeTimes={excluded}
      onChange={date =>
        onChange({ hour: date.getHours(), minutes: date.getMinutes() })
      }
    />
  ) : calendarType === "multiSelect" ? (
    <DatePicker
      maxDate={new Date()}
      className={classnames("form-group form-control", className)}
      dateFormat="DD-MM-YYYY"
      placeholderText={placeholder}
      onChange={date => onChange(date)}
      monthsShown={2}
      selectsRange={true}
      startDate={startDate}
      endDate={endDate}
      customInput={<MultiDateInput />}
      calendarContainer={DefaultContainer}
      shouldCloseOnSelect={false}
    />
  ) : (
    <DatePicker
      className={classnames("form-group form-control", className)}
      selected={value || undefined}
      dateFormat={customInput ? "MM-dd-yyyy" : "MM-dd-yyyy"}
      minDate={
        !type
          ? (previousDate && add(previousDate, { days: 1 })) ||
            sDate ||
            new Date()
          : sDate
      }
      maxDate={
        type && id !== "endDate"
          ? MaxDate ? MaxDate : new Date()
          : id !== "endDate" && add(new Date(), { years: 5 })
      }
      customInput={customInput ? <CustomInput /> : null}
      placeholderText={placeholder}
      onChange={date => onChange(date)}
      showMonthDropdown
      showYearDropdown
      dropdownMode="scroll"
    />
  );
};

export default DateTimePicker;
